import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ConfiguracaoDFeGeralRequest } from '../../requests/dfe/configuracao-dfe-geral.request';
import { SimularConfiguracaoDFeGeralRequest } from '../../requests/dfe/simular-configuracao-dfe-geral.request';
import { ConfiguracaoDFeGeralResponse } from '../../responses/dfe/configuracao-dfe-geral.response';
import { SimularConfiguracaoDFeGeralResponse } from '../../responses/dfe/simular-configuracao-dfe-geral.response';

@Injectable({
  providedIn: 'root',
})
export class ConfiguracaoDFeGeralService extends CommonService {
  private readonly apiUrl = `${environment.urlApiDFe}configuracao-dfe-geral`;

  // Emite quando a configuração geral é salva, para o alert-banner reconsultar o ambiente.
  private readonly alteracoesSubject = new Subject<void>();
  public readonly alteracoes$ = this.alteracoesSubject.asObservable();

  constructor(private httpClient: HttpClient) {
    super();
  }

  /**
   * Obtém a configuração geral do DFe da empresa. A API provisiona
   * automaticamente a configuração quando ainda não existir.
   * Corresponde a: [HttpGet] /configuracao-dfe-geral
   */
  public get(idEmpresa?: number): Observable<ConfiguracaoDFeGeralResponse> {
    return this.httpClient
      .get<ConfiguracaoDFeGeralResponse>(this.apiUrl, this.criarOptions(idEmpresa))
      .pipe(catchError(this.handleError));
  }

  /** Notifica que a configuração geral foi salva (o alert-banner reconsulta o aviso de homologação). */
  public notificarAlteracao(): void {
    this.alteracoesSubject.next();
  }

  /**
   * Salva o ambiente geral e atualiza o ambiente dos emissores marcados como Automático.
   * Corresponde a: [HttpPut] /configuracao-dfe-geral
   */
  public atualizar(request: ConfiguracaoDFeGeralRequest, idEmpresa?: number): Observable<ConfiguracaoDFeGeralResponse> {
    return this.httpClient
      .put<ConfiguracaoDFeGeralResponse>(this.apiUrl, request, this.criarOptions(idEmpresa))
      .pipe(catchError(this.handleError));
  }

  /**
   * Simula a troca de ambiente sem gravar: devolve os conflitos de série e os emissores afetados.
   * Corresponde a: [HttpPut] /configuracao-dfe-geral/simular
   */
  public simular(request: SimularConfiguracaoDFeGeralRequest, idEmpresa?: number): Observable<SimularConfiguracaoDFeGeralResponse> {
    return this.httpClient
      .put<SimularConfiguracaoDFeGeralResponse>(`${this.apiUrl}/simular`, request, this.criarOptions(idEmpresa))
      .pipe(catchError(this.handleError));
  }

  private criarOptions(idEmpresa?: number) {
    return idEmpresa
      ? { ...this.addHeaderToken(), params: new HttpParams().set('idEmpresa', idEmpresa) }
      : this.addHeaderToken();
  }
}
